// import files which should run when the app is initialized

import(/* webpackChunkName: "vendors/polyfills" */ './polyfills');
import(/* webpackChunkName: "vendors/cookieConsent" */ './cookieConsentV2');
import(/* webpackChunkName: "vendors/fontawesome-icons" */ './fontawesomeIcons');
import(/* webpackChunkName: "vendors/emoji-parser" */ './emoji-parser');
import(/* webpackChunkName: "vendors/dialogflow-cx-messenger" */ './dialogflow-cx-messenger');

import { TelemetryRunner } from '@/Telemetry';
import { startViewPortListener } from '../hooks';
import './window.util';

startViewPortListener();
TelemetryRunner.run();
